import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.string.trim";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getGoodsinList, getSellerList, getGoodsspuList, getGoodsList, getSupplierList, goodsinCreate, goodsinUpdate, goodsinSubmit, goodsinFind, goodsinCheck, goodsinDelete, goodsinCopy } from '@/api/bairun/bianlidian'; //  此处请自行替换地址

import * as DateUtil from '@/utils/date';
import infoList from '@/mixins/infoList';
import AddSPUDialog from '@/view/bianlidianManage/goodsspu/add';
import { afterDiffDate, afterDiffMonth, afterDiffYear } from "../../../utils/date";

var _this;

export default {
  name: 'BianlidianGoodsIn',
  components: {
    AddSPUDialog: AddSPUDialog
  },
  filters: {
    formatDate: function formatDate(time, format) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return DateUtil.formatTimeToStr(date, 'yyyy-MM-dd');
      } else {
        return '';
      }
    },
    formatDateTime: function formatDateTime(time, format) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return DateUtil.formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    },
    getSellerName: function getSellerName(id) {
      for (var i = 0; i < _this.sellerOptions.length; i++) {
        if (_this.sellerOptions[i].sellerId == id) {
          return _this.sellerOptions[i].sellerName;
        }
      }

      return '';
    },
    getSupplierName: function getSupplierName(supplierNo) {
      for (var i = 0; i < _this.supplierOptions.length; i++) {
        if (_this.supplierOptions[i].supplierNo == supplierNo) {
          return _this.supplierOptions[i].name;
        }
      }

      return '';
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getGoodsinList,
      type: '',
      multipleSelection: [],
      sellerOptions: [],
      supplierOptions: [],
      viewAndAuditdialogVisible: false,
      addDialogVisible: false,
      spuNo: '',
      isShowGoodsAdd: false,
      goodsLoading: false,
      goodsOptions: [],
      goodsSellerId: '',
      supplierNo: '',
      goodsRemark: '',
      goodsinAmountSummary: 0,
      goodsinNumSummary: 0,
      swichAuto: true,
      isNeedReimburse: true,
      goodsInTableData: [],
      goodsInTableView: [],
      // 商品库组件-绑定参数
      addSPUDialogFormData: {
        type: '',
        dialogVisible: false,
        formData: {}
      },
      formData: {
        auditRemark: '',
        auditStatus: '',
        goodsInNo: '',
        sellerId: ''
      },
      auditRules: {
        auditRemark: [{
          required: true,
          message: '请输入审核意见',
          trigger: 'blur'
        }],
        auditStatus: [{
          required: true,
          message: '请选择审核结果',
          trigger: 'blur'
        }]
      }
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var sellerOptions, supplierOptions;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log('goodsin init');
                _context3.next = 3;
                return getSellerList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 3:
                sellerOptions = _context3.sent;
                _this.sellerOptions = sellerOptions.data.list;
                _context3.next = 7;
                return getSupplierList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 7:
                supplierOptions = _context3.sent;
                _this.supplierOptions = supplierOptions.data.list;

                _this.getTableData();

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.searchInfo.auditAtStart = this.$options.filters.formatDateTime(this.searchInfo.auditAtStart, 'yyyy-MM-dd hh:mm:ss');
      this.searchInfo.auditAtEnd = this.$options.filters.formatDateTime(this.searchInfo.auditAtEnd, 'yyyy-MM-dd hh:mm:ss');
      this.getTableData();
    },
    onReset: function onReset() {
      debugger;
      this.searchInfo = {};
      this.onSubmit();
    },
    handleSelChange: function handleSelChange(val) {
      this.multipleSelection = val;
    },
    // 解决input无法输入问题
    inputChange: function inputChange() {
      if (this.viewAndAuditdialogVisible) {
        this.countGoodsinAmountSummary(this.goodsInTableView);
      }

      if (this.addDialogVisible) {
        this.countGoodsinAmountSummary(this.goodsInTableData);
      }

      this.$forceUpdate();
    },
    // 输入数量
    onInputGoodsinNum: function onInputGoodsinNum(row) {
      console.log('onInputGoodsinNum');
      var that = this;

      if (that.swichAuto) {
        if (row.goodsInNum != '' && parseFloat(row.goodsInNum) != 0 && row.goodsCost != '' && parseFloat(row.goodsCost) != 0) {
          row.goodsInAmount = (parseFloat(row.goodsInNum || 0) * parseFloat(row.goodsCost || 0)).toFixed(2);
        } else {
          row.goodsInAmount = '';
        }
      }

      if (this.viewAndAuditdialogVisible) {
        this.countGoodsinAmountSummary(this.goodsInTableView);
      }

      if (this.addDialogVisible) {
        this.countGoodsinAmountSummary(this.goodsInTableData);
      }

      this.$forceUpdate();
    },
    // 输入总金额
    onInputGoodsinAmount: function onInputGoodsinAmount(row) {
      console.log('onInputGoodsinAmount');
      var that = this;

      if (that.swichAuto) {
        if (row.goodsInNum != '' && parseFloat(row.goodsInNum) != 0 && row.goodsInAmount != '' && parseFloat(row.goodsInAmount) != 0) {
          row.goodsCost = (parseFloat(row.goodsInAmount || 0) / parseFloat(row.goodsInNum)).toFixed(2);
        } else {
          row.goodsCost = '';
        }
      }

      if (this.viewAndAuditdialogVisible) {
        this.countGoodsinAmountSummary(this.goodsInTableView);
      }

      if (this.addDialogVisible) {
        this.countGoodsinAmountSummary(this.goodsInTableData);
      }

      this.$forceUpdate();
    },
    // 输入保质期
    onInputGoodsValidDay: function onInputGoodsValidDay(row) {
      if (isNaN(row.validDay) || row.validDay <= 0) {
        row.validDay = '';
        return;
      }

      row.validDay = row.validDay.trim();
      if (row.validDayType == 1) row.dateEnd = DateUtil.afterDiffDate(new Date(row.dateStart).Format('yyyy-MM-dd 00:00:00'), Number(row.validDay));
      if (row.validDayType == 2) row.dateEnd = DateUtil.afterDiffMonth(new Date(row.dateStart).Format('yyyy-MM-dd 00:00:00'), Number(row.validDay));
      if (row.validDayType == 3) row.dateEnd = DateUtil.afterDiffYear(new Date(row.dateStart).Format('yyyy-MM-dd 00:00:00'), Number(row.validDay));
    },
    // 汇总商品数量
    countGoodsinAmountSummary: function countGoodsinAmountSummary(tableData) {
      var that = this;
      var goodsinAmountSummary = 0;
      var goodsinNumSummary = 0;

      if (tableData.length > 0) {
        tableData.forEach(function (item) {
          goodsinAmountSummary += item.goodsInAmount !== '' ? parseFloat(item.goodsInAmount) : 0;
          goodsinNumSummary += item.goodsInNum !== '' ? parseInt(item.goodsInNum) : 0;
        });
        goodsinAmountSummary = goodsinAmountSummary.toFixed(2);
        goodsinNumSummary = goodsinNumSummary.toFixed(2);
      }

      that.goodsinAmountSummary = goodsinAmountSummary;
      that.goodsinNumSummary = goodsinNumSummary;
    },
    // 商品库搜索
    goodsSearch: function goodsSearch(query) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var that;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                that = _this3;
                that.handleGoodsSearch(query, '', function (res, isExit, queryName, goodsNo) {
                  // 默认添加
                  if (isExit && queryName === 'goodsNo') {
                    that.spuNo = that.goodsOptions[0].spuNo;
                    that.onGoodsSel();
                    that.$refs.goodsSearchSelect.blur();
                    that.spuNo = '';
                    setTimeout(function () {
                      that.$refs.goodsSearchSelect.focus();
                    }, 50);
                  } // 扫条形码，不存在


                  if (!isExit && queryName === 'goodsNo') {
                    that.$message({
                      type: 'warning',
                      message: '商品不存在，请尝试根据名称搜索'
                    });
                  } // 名称搜索，不存在，弹框新增


                  if (!isExit && queryName === 'goodsName') {
                    that.showAddSPUDialog();
                  }
                });

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    handleGoodsSearch: function handleGoodsSearch(query, queryName, fn) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var that, param, result, isExit;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                console.log('handleGoodsSearch:' + queryName);
                that = _this4;

                if (!(query === '')) {
                  _context5.next = 5;
                  break;
                }

                that.goodsOptions = [];
                return _context5.abrupt("return");

              case 5:
                that.goodsOptions = [];
                that.goodsLoading = true;
                param = {};

                if (queryName && queryName === 'goodsName') {
                  param.goodsName = query;
                } else if (queryName && queryName === 'goodsNo') {
                  param.goodsNo = query;
                } else if (isNaN(query)) {
                  param.goodsName = query;
                  queryName = 'goodsName';
                } else {
                  param.goodsNo = query;
                  queryName = 'goodsNo';
                }

                result = {};

                if (!(queryName === 'goodsNo')) {
                  _context5.next = 14;
                  break;
                }

                _context5.next = 13;
                return getGoodsList({
                  'goodsNo': param.goodsNo,
                  'sellerId': that.goodsSellerId,
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 13:
                result = _context5.sent;

              case 14:
                if (!(queryName === 'goodsName')) {
                  _context5.next = 18;
                  break;
                }

                _context5.next = 17;
                return getGoodsspuList({
                  'goodsName': param.goodsName,
                  'sellerId': that.goodsSellerId,
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 17:
                result = _context5.sent;

              case 18:
                that.goodsLoading = false; // 存在

                isExit = false;

                if (result.data.list && result.data.list.length > 0) {
                  isExit = true; // 扫条形码

                  if (param.goodsNo) {
                    result.data.list.forEach(function (item) {
                      that.goodsOptions.push({
                        'sellerId': that.goodsSellerId,
                        'goodsName': item.goodsName,
                        'spuNo': item.spuNo,
                        'hasGoodsNo': param.goodsNo != '',
                        'goodsNo': param.goodsNo,
                        'goodsCost': item.goodsLatestCost,
                        'goodsPrice': item.goodsPrice && item.goodsPrice != '' && parseFloat(item.goodsPrice) > 0 ? item.goodsPrice : item.goodsOfficialPrice,
                        'goodsPriceText': item.goodsPrice && item.goodsPrice != '' && parseFloat(item.goodsPrice) > 0 ? '最新销售价' : '销售指导价',
                        'categoryNo': item.categoryNo,
                        'categoryName': item.categoryName,
                        'supplierNo': '',
                        'supplierName': '',
                        'goodsType': item.goodsType,
                        'goodsInNum': 1,
                        'goodsStock': item.goodsStock,
                        'goodsUnit': item.goodsUnit,
                        'goodsSpecification': item.goodsSpecification,
                        'goodsInAmount': 0,
                        'validDay': '',
                        'validDayType': '2',
                        'dateStart': '',
                        'dateEnd': '',
                        'remark': ''
                      });
                    });
                  } // 名称搜索


                  if (param.goodsName) {
                    result.data.list.forEach(function (item) {
                      that.goodsOptions.push({
                        'sellerId': that.goodsSellerId,
                        'goodsName': item.goodsName,
                        'spuNo': item.spuNo,
                        'hasGoodsNo': item.goodsNo != '',
                        'goodsNo': item.goodsNo,
                        'goodsCost': item.goodsLatestCost,
                        'categoryNo': item.categoryNo,
                        'categoryName': item.categoryName,
                        'supplierNo': '',
                        'supplierName': '',
                        'goodsType': item.goodsType,
                        'goodsInNum': 1,
                        'goodsStock': item.goodsStock,
                        'goodsUnit': item.goodsUnit,
                        'goodsSpecification': item.goodsSpecification,
                        'goodsInAmount': 0,
                        'goodsPrice': item.goodsPrice && item.goodsPrice != '' && parseFloat(item.goodsPrice) > 0 ? item.goodsPrice : item.goodsOfficialPrice,
                        'goodsPriceText': item.goodsPrice && item.goodsPrice != '' && parseFloat(item.goodsPrice) > 0 ? '最新销售价' : '销售指导价',
                        'validDay': '',
                        'validDayType': '2',
                        'dateStart': '',
                        'dateEnd': '',
                        'remark': ''
                      });
                    });
                  }
                }

                if (fn) {
                  fn(result.data.list && result.data.list.length > 0 ? result.data.list : [], isExit, queryName, param.goodsNo);
                }

              case 22:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    // 选中便利店商品
    onGoodsSel: function onGoodsSel() {
      var _this5 = this;

      debugger;
      var that = this;

      if (that.goodsSellerId === '') {
        that.$message({
          type: 'warning',
          message: '请选择便利店'
        });
        return;
      }

      var goods = this.goodsOptions.filter(function (item) {
        // eslint-disable-next-line eqeqeq
        return that.spuNo == item.spuNo;
      });

      if (goods.length > 0) {
        goods[0].supplierNo = that.supplierNo;
        this.handleAddGoodsIn(goods[0]);

        if (this.$refs.goodsSearchSelect) {
          this.spuNo = '';
          this.$refs.goodsSearchSelect.blur();
          setTimeout(function () {
            _this5.$refs.goodsSearchSelect.focus();
          }, 100);
        }
      }
    },
    // 添加入库记录
    handleAddGoodsIn: function handleAddGoodsIn(goods) {
      var _this6 = this;

      var that = this;
      var isExit = false;
      that.goodsInTableData.forEach(function (item) {
        // eslint-disable-next-line eqeqeq
        if (goods.spuNo == item.spuNo) {
          isExit = true;
        }
      });

      if (!isExit) {
        that.goodsInTableData.splice(that.goodsInTableData.length, 0, JSON.parse(JSON.stringify(goods)));
        that.countGoodsinAmountSummary(that.goodsInTableData);
      }

      this.$nextTick(function () {
        _this6.$refs.goodsInTable.bodyWrapper.scrollTop = _this6.$refs.goodsInTable.bodyWrapper.firstChild.clientHeight;
      });
    },
    // 商品库组件-添加弹框
    showAddSPUDialog: function showAddSPUDialog() {
      var that = this;
      that.addSPUDialogFormData.type = 'add';
      that.addSPUDialogFormData.dialogVisible = true;
      that.addSPUDialogFormData.formData = {};
    },
    // 商品库组件-回调
    handleSPUDialogCallback: function handleSPUDialogCallback(res) {
      debugger;
      var that = this;
      that.handleAddGoodsIn({
        'sellerId': that.goodsSellerId,
        'goodsName': res.goodsName,
        'categoryNo': res.categoryNo,
        'categoryName': res.categoryName,
        'supplierNo': that.supplierNo,
        'supplierName': '',
        'spuNo': res.spuNo,
        'hasGoodsNo': false,
        'goodsNo': '',
        'goodsCost': '',
        'goodsType': 2,
        'goodsInNum': 1,
        'goodsUnit': res.goodsUnit,
        'goodsSpecification': res.goodsSpecification,
        'goodsInAmount': 0,
        'goodsStock': 0,
        'goodsPrice': res.goodsOfficialPrice,
        'dateStart': '',
        'dateEnd': '',
        'remark': ''
      });
    },
    // 商品库组件-关闭
    handelSPUDialogClose: function handelSPUDialogClose() {
      this.addSPUDialogFormData.dialogVisible = false;
    },
    onDelGoods: function onDelGoods(row) {
      var that = this;
      that.goodsInTableData = that.goodsInTableData.filter(function (item) {
        return item.spuNo != row.spuNo;
      });
      this.countGoodsinAmountSummary(that.goodsInTableData);
    },
    // 新增入库
    onAdd: function onAdd() {
      var that = this;
      that.addDialogVisible = true;
      that.type = 'add';
      that.goodsInTableData = localStorage.getItem('goodsInTableData') ? JSON.parse(localStorage.getItem('goodsInTableData')) : [];
      that.isNeedReimburse = localStorage.getItem('isNeedReimburse') == 'true';
    },
    // 变更
    onUpdate: function onUpdate(row) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var that, res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                that = _this7;
                that.addDialogVisible = true;
                that.type = 'update';
                _context6.next = 5;
                return goodsinFind({
                  'goodsInNo': row.goodsInNo
                });

              case 5:
                res = _context6.sent;

                if (res.code == 0) {
                  that.formData.goodsInNo = row.goodsInNo;

                  if (res.data.list && res.data.list.length > 0) {
                    that.goodsSellerId = res.data.list[0].sellerId;
                    that.supplierNo = res.data.list[0].supplierNo;
                    that.countGoodsinAmountSummary(res.data.list);
                    that.swichAuto = false; // 关闭自动计算，防止重新计算后产生精度问题

                    that.isNeedReimburse = res.data.list[0].isNeedReimburse == 1;
                    that.goodsInTableData = res.data.list;

                    _this7.$nextTick(function () {
                      setTimeout(function () {
                        // 500毫秒后重新开启自动计算
                        that.swichAuto = true;
                      }, 500);
                    });
                  }
                }

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    onView: function onView(row) {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var that, res;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                that = _this8;
                _context7.next = 3;
                return goodsinFind({
                  'goodsInNo': row.goodsInNo
                });

              case 3:
                res = _context7.sent;

                // eslint-disable-next-line eqeqeq
                if (res.code == 0) {
                  that.goodsInTableView = res.data.list; // for(var i = 0 ; i < 20; i++){
                  //   that.goodsInTableData.push(row)
                  // }

                  that.formData.goodsInNo = row.goodsInNo;

                  _this8.countGoodsinAmountSummary(that.goodsInTableView);
                }

                _this8.type = 'view';
                _this8.viewAndAuditdialogVisible = true;

              case 7:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    // 审核
    onSubmitAudit: function onSubmitAudit(row) {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var that;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                that = _this9;
                that.$confirm('提审后不能再修改，确定【' + (row.isNeedReimburse == 1 ? '需报销' : '不报销') + '】吗？', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(function () {
                  goodsinSubmit({
                    'sellerId': row.sellerId,
                    'goodsInNo': row.goodsInNo
                  }).then(function (res) {
                    // eslint-disable-next-line eqeqeq
                    if (res.code == 0) {
                      that.$message({
                        type: 'success',
                        message: res.msg
                      });
                      that.getTableData();
                    } // eslint-disable-next-line handle-callback-err

                  }, function (err) {});
                }).catch(function (err) {});

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    // 审核
    onAudit: function onAudit(row) {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var that, res;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                that = _this10;
                _context9.next = 3;
                return goodsinFind({
                  'goodsInNo': row.goodsInNo
                });

              case 3:
                res = _context9.sent;

                // eslint-disable-next-line eqeqeq
                if (res.code == 0) {
                  that.goodsInTableView = res.data.list; // for(var i = 0 ; i < 20; i++){
                  //   that.goodsInTableData.push(res.data.list[0])
                  // }

                  that.formData.goodsInNo = row.goodsInNo;
                  that.formData.sellerId = row.sellerId;

                  _this10.countGoodsinAmountSummary(that.goodsInTableView);
                }

                _this10.type = 'audit';
                _this10.viewAndAuditdialogVisible = true;

              case 7:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    },
    onAuditSubmit: function onAuditSubmit() {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var that;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                that = _this11;

                if (!that.loading) {
                  _context11.next = 3;
                  break;
                }

                return _context11.abrupt("return");

              case 3:
                that.loading = true;
                that.loadingText = '加载中...';
                that.$refs['auditForm'].validate( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(valid) {
                    return regeneratorRuntime.wrap(function _callee10$(_context10) {
                      while (1) {
                        switch (_context10.prev = _context10.next) {
                          case 0:
                            if (!valid) {
                              that.loading = false;
                              that.loadingText = '';
                            }

                            if (valid) {
                              goodsinCheck({
                                'sellerId': that.formData.sellerId,
                                'goodsInNo': that.formData.goodsInNo,
                                'auditStatus': parseInt(that.formData.auditStatus),
                                'auditRemark': that.formData.auditRemark
                              }).then(function (res) {
                                if (res.code == 0) {
                                  that.$message({
                                    type: 'success',
                                    message: res.msg
                                  });
                                  that.closeDialog();
                                  that.getTableData();
                                }
                              }, function (error) {
                                that.loading = false;
                                that.loadingText = '';
                              });
                            }

                          case 2:
                          case "end":
                            return _context10.stop();
                        }
                      }
                    }, _callee10);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 6:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }))();
    },
    // 删除
    onDelete: function onDelete(row) {
      var that = this;
      that.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        goodsinDelete({
          'sellerId': row.sellerId,
          'goodsInNo': row.goodsInNo
        }).then(function (res) {
          // eslint-disable-next-line eqeqeq
          if (res.code == 0) {
            that.$message({
              type: 'success',
              message: res.msg
            });
            that.getTableData();
          } // eslint-disable-next-line handle-callback-err

        }, function (err) {});
      }).catch(function (err) {});
    },
    // 复制
    onCopy: function onCopy(row) {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var res;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (!_this12.loading) {
                  _context12.next = 2;
                  break;
                }

                return _context12.abrupt("return");

              case 2:
                _this12.loading = true;
                _context12.next = 5;
                return goodsinCopy({
                  'sellerId': row.sellerId,
                  'goodsInNo': row.goodsInNo
                });

              case 5:
                res = _context12.sent;
                // eslint-disable-next-line eqeqeq
                _this12.loading = false;

                if (res.code == 0) {
                  _this12.$message({
                    type: 'success',
                    message: res.msg
                  });

                  _this12.getTableData();
                }

              case 8:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }))();
    },
    closeDialog: function closeDialog() {
      if (this.type === 'add' && this.goodsInTableData.length) {
        localStorage.setItem('isNeedReimburse', this.isNeedReimburse);
        localStorage.setItem('goodsInTableData', JSON.stringify(this.goodsInTableData));
      }

      this.addDialogVisible = false;
      this.viewAndAuditdialogVisible = false;
      this.goodsOptions = [];
      this.goodsSellerId = '';
      this.spuNo = '';
      this.goodsLoading = false;
      this.supplierNo = '';
      this.goodsinAmountSummary = 0;
      this.goodsinNumSummary = 0;
      this.type = '';
      this.loading = false;
      this.loadingText = '';
      this.formData = {
        auditRemark: '',
        auditStatus: '',
        goodsInNo: '',
        sellerId: ''
      };
    },
    onClearGoodsIn: function onClearGoodsIn() {
      localStorage.removeItem('goodsInTableData');
      localStorage.removeItem('isNeedReimburse');
      this.goodsInTableData = [];
    },
    enterDialog: function enterDialog() {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var that, validMsg, param;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                that = _this13;
                validMsg = that.validAddForm();

                if (!(validMsg !== '')) {
                  _context13.next = 5;
                  break;
                }

                that.$message({
                  type: 'warning',
                  message: validMsg
                });
                return _context13.abrupt("return");

              case 5:
                if (!that.loading) {
                  _context13.next = 7;
                  break;
                }

                return _context13.abrupt("return");

              case 7:
                that.loading = true;
                that.loadingText = '加载中...';
                param = {
                  sellerId: that.goodsSellerId,
                  remark: that.goodsRemark,
                  goodsInNo: that.formData.goodsInNo,
                  isNeedReimburse: that.isNeedReimburse ? 1 : 2
                };

                if (that.type === 'add') {
                  param.list = that.goodsInTableData;
                  goodsinCreate(param).then(function (res) {
                    // eslint-disable-next-line eqeqeq
                    if (res.code == 0) {
                      that.$message({
                        type: 'success',
                        message: res.msg
                      });
                      that.closeDialog();
                      that.getTableData();
                      that.onClearGoodsIn();
                    } else {
                      that.loading = false;
                      that.loadingText = '';
                    } // eslint-disable-next-line handle-callback-err

                  }, function (err) {
                    that.loading = false;
                    that.loadingText = '';
                  });
                }

                if (that.type === 'update') {
                  param.list = that.goodsInTableData;
                  goodsinUpdate(param).then(function (res) {
                    // eslint-disable-next-line eqeqeq
                    if (res.code == 0) {
                      that.$message({
                        type: 'success',
                        message: res.msg
                      });
                      that.closeDialog();
                      that.getTableData();
                      that.onClearGoodsIn();
                    } else {
                      that.loading = false;
                      that.loadingText = '';
                    } // eslint-disable-next-line handle-callback-err

                  }, function (err) {
                    that.loading = false;
                    that.loadingText = '';
                  });
                }

              case 12:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }))();
    },
    validAddForm: function validAddForm() {
      var that = this;
      var validMsg = '';

      if (that.goodsSellerId === '') {
        validMsg = '请选择便利店';
        return validMsg;
      }

      that.goodsInTableData.forEach(function (obj, index) {
        if (obj.supplierNo === '') {
          validMsg = '商品【' + obj.goodsName + '】，供应商不能为空';
          return;
        } // if (obj.goodsNo === '') {
        //   validMsg = '商品【' + obj.goodsName + '】，条形码不能为空'
        //   return
        // }
        // if (obj.goodsNo.length < 6) {
        //   validMsg = '商品【' + obj.goodsName + '】，条形码最少6位以上'
        //   return
        // }


        if (obj.goodsCost === '') {
          validMsg = '商品【' + obj.goodsName + '】，成本价不能为空';
          return;
        }

        if (parseFloat(obj.goodsCost) <= 0) {
          validMsg = '商品【' + obj.goodsName + '】，成本价不能小于等于0';
          return;
        }

        if (obj.goodsPrice === '') {
          validMsg = '商品【' + obj.goodsName + '】，销售价不能为空';
          return;
        }

        if (parseFloat(obj.goodsPrice) < 0) {
          validMsg = '商品【' + obj.goodsName + '】，销售价不能小于0';
          return;
        } // if (obj.goodsInNum === '') {
        //   validMsg = '商品【' + obj.goodsName + '】，入库数量不能为空'
        //   return
        // }
        // if (parseFloat(obj.goodsInNum) <= 0) {
        //   validMsg = '商品【' + obj.goodsName + '】，入库数量不能小于等于0'
        //   return
        // }


        if (obj.goodsInNum != '' && obj.goodsInNum > 0 && obj.goodsInAmount === '') {
          validMsg = '商品【' + obj.goodsName + '】，入库金额不能为空';
          return;
        }

        if (obj.goodsInNum != '' && obj.goodsInNum > 0 && parseFloat(obj.goodsInAmount) <= 0) {
          validMsg = '商品【' + obj.goodsName + '】，入库金额不能小于等于0';
          return;
        }

        if (parseFloat(obj.goodsCost) > parseFloat(obj.goodsPrice)) {
          validMsg = '商品【' + obj.goodsName + '】，成本价不能大于销售价';
          return;
        }

        obj.dateStart = that.$options.filters.formatDate(obj.dateStart, 'yyyy-MM-dd');
        obj.dateEnd = that.$options.filters.formatDate(obj.dateEnd, 'yyyy-MM-dd');
        obj.goodsNo = obj.goodsNo + '';
        obj.goodsCost = parseFloat(obj.goodsCost || 0);
        obj.goodsPrice = parseFloat(obj.goodsPrice || 0);
        obj.goodsInNum = parseInt(obj.goodsInNum || 0);
        obj.goodsInAmount = parseFloat(obj.goodsInAmount || 0);
        obj.supplierNo = parseInt(obj.supplierNo || 0);
        obj.remark = that.goodsRemark;
      });
      return validMsg;
    }
  }
};